import React, {useEffect} from "react";
import {Link, Redirect} from "react-router-dom";
import {connect, useSelector} from "react-redux";

export function LandingPage() {

    useEffect(() => {
        localStorage.removeItem("logged_in");
    }, []);

    const status = useSelector((state) => state.auth.status);

    return (
        <div className="flex-column center flex1">
            {status !== "authenticated" ?
            <Redirect to="/login" />
            : 
            <Redirect to="/dashboard" />
            
            }
        </div>
    )
}

const mapStateToProps = () => ({})

export default connect(mapStateToProps)(LandingPage);
